var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3.9688mm",
    height: "10.583mm",
    viewBox: "0 0 3.96875 10.583333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-252.02 -343.11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 655.54 498.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1525.1-587.31h15v40h-15z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.88464 -4.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1521.9-557.78h6.8131v6.8132h-6.8131z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.30d0f1ccd79dee65d198bd4a53371783.svg";
export { ForwardRef as ReactComponent };